var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPwReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 36,
    height: 36,
    transform: "translate(-0.099 -0.099)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0.099 0.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M12.657,0c.43.093.865.164,1.289.281a7.429,7.429,0,0,1,5.433,6.966c.021.92.007,1.841.009,2.761,0,.126,0,.252,0,.429.377,0,.722-.006,1.067,0a3.363,3.363,0,0,1,3.354,2.754,2.024,2.024,0,0,1,.042.381c.006,1.573.014,3.146.007,4.719a1.1,1.1,0,0,1-.842,1.069,1.082,1.082,0,0,1-1.222-.532,1.754,1.754,0,0,1-.161-.736c-.015-1.363-.006-2.726-.008-4.089A1.157,1.157,0,0,0,20.3,12.674H6.077c-.85,0-1.7,0-2.55,0a1.154,1.154,0,0,0-1.289,1.3q0,6.169,0,12.339A1.152,1.152,0,0,0,3.531,27.6q6.519,0,13.038,0a1.257,1.257,0,0,1,1,.324,1.109,1.109,0,0,1-.525,1.87,2.372,2.372,0,0,1-.52.045q-6.449,0-12.9,0A3.366,3.366,0,0,1,.047,27.015.454.454,0,0,0,0,26.922V13.356a.77.77,0,0,0,.054-.128,3.363,3.363,0,0,1,3.459-2.792c.311,0,.621,0,.962,0,0-.155,0-.269,0-.383,0-.908-.007-1.816,0-2.725A7.4,7.4,0,0,1,9.15.557,19.84,19.84,0,0,1,11.188,0ZM6.651,10.414H17.144c0-1.055.021-2.089,0-3.122a5.207,5.207,0,0,0-4.782-5.041A5.116,5.116,0,0,0,6.875,6.319a32.056,32.056,0,0,0-.224,4.1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M241.665,229.063a1.34,1.34,0,0,1-1.443.848c-.826-.037-1.654-.008-2.481-.009a1.154,1.154,0,0,1-1.3-1.108,1.142,1.142,0,0,1,1.241-1.131,1.109,1.109,0,0,0,.11-.02,2.652,2.652,0,0,0-.185-.2,5.2,5.2,0,0,0-8.311,2.2,1.293,1.293,0,0,1-.8.941,1.116,1.116,0,0,1-1.4-1.426,7.46,7.46,0,0,1,12.116-3.289c.051.045.1.09.192.172.01-.105.018-.167.021-.228a1.118,1.118,0,0,1,2.13-.488c.032.058.072.112.108.168Z",
    transform: "translate(-205.863 -203.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M230.824,318.716c-.61-.142-1.232-.243-1.827-.434a6.8,6.8,0,0,1-2.4-1.392c-.094-.082-.19-.159-.307-.257-.025.171-.036.309-.065.442a1.1,1.1,0,0,1-1.2.881,1.073,1.073,0,0,1-.988-1.042q-.024-1.555,0-3.111a1.054,1.054,0,0,1,1.092-1.043c.99-.013,1.981-.011,2.971,0a1.091,1.091,0,0,1,1.13,1.011,1.108,1.108,0,0,1-1,1.212c-.091.013-.184.017-.32.029a1.732,1.732,0,0,0,.157.187,5.205,5.205,0,0,0,8.308-2.148c.036-.1.071-.2.11-.294a1.114,1.114,0,0,1,2.109.719,7.455,7.455,0,0,1-6.07,5.171,2.62,2.62,0,0,0-.3.071Z",
    transform: "translate(-203.133 -282.914)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwReset);
export default __webpack_public_path__ + "static/media/pw-reset.606948db82ecc380ab61f510713c9e5b.svg";
export { ForwardRef as ReactComponent };